<template>
    <el-col :cols="cols" :lg="lg">
        <label class="v-label font-weight-medium mb-2">{{ label }}</label>
        <div v-if="editor">
            <EditorMenubar :editor="editor" />
        </div>
        <EditorContent :editor="editor" />
    </el-col>
</template>

<script>
    import StarterKit from '@tiptap/starter-kit'
    import Link from '@tiptap/extension-link'
    import { Editor, EditorContent } from '@tiptap/vue-3'
    import EditorMenubar from './EditorMenubar.vue'

    export default {
        components: {
            EditorContent,
            EditorMenubar,
        },
        props: {
            modelValue: {
                type: String,
                default: '',
            },
            label: {
                type: String,
                default: 'Text',
            },
            cols: {
                type: String,
                default: 12,
            },
            lg: {
                type: String,
                default: 6,
            },
        },
        emits: ['update:modelValue'],
        data() {
            return {
                editor: null,
            }
        },
        watch: {
            modelValue(value) {
                if (this.editor) {
                    const isSame = this.editor.getHTML() === value
                    if (!isSame) {
                        this.editor.commands.setContent(value, false)
                    }
                }
            },
        },
        mounted() {
            this.editor = new Editor({
                extensions: [
                    StarterKit,
                    Link.configure({
                        openOnClick: false,
                        HTMLAttributes: {
                            rel: null, // Allow search engines to follow links
                            target: null, // Open links in the current tab
                        },
                    }),
                ],
                content: this.modelValue,
                onUpdate: ({ editor }) => {
                    this.$emit('update:modelValue', editor.getHTML())
                },
            })
        },
        beforeUnmount() {
            if (this.editor) {
                this.editor.destroy()
            }
        },
    }
</script>
